import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import axiosInstance from '../utils/axiosInstance';
import { plotlyStyle } from '../utils/plotlyStyle';
import { Stack, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { MESSAGES } from '../constants/messages';

const ChartUnitPrice = () => {
    const [month, setMonth] = useState(dayjs());
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async (targetMonth) => {
        setLoading(true);

        try {
            const res = await axiosInstance.get('/chart/unit-price', {
                params: {
                    month: targetMonth.format('YYYY-MM'),
                },
            });

            setData(res.data);
            setError(null);
        } catch (err) {
            setError('データ取得に失敗しました');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(month);
    }, [month]);

    if (loading) {
        return <Typography>{MESSAGES.LOADING}</Typography>;
    }

    if (error) {
        return <Typography>{error || MESSAGES.LOAD_FAILED}</Typography>;
    }

    const plotData = [
        {
            x: data.map(item => item.order_number),
            y: data.map(item => item.unit_price),
            type: 'scatter',
            mode: 'markers',
            name: '客単価',
            marker: {
                color: plotlyStyle.colors.primary,
            },
            hovertemplate:
                '注文番号: %{x}<br>客単価: %{y:,} 円<extra></extra>',
        },
        {
            x: data.map(item => item.order_number),
            y: data.map(item => item.avg_quantity),
            type: 'scatter',
            mode: 'markers',
            name: '平均注文数',
            marker: {
                color: plotlyStyle.colors.secondary,
            },
            yaxis: 'y2',
            hovertemplate:
                '注文番号: %{x}<br>平均注文数: %{y}<extra></extra>',
        },
    ];

    const layout = {
        ...plotlyStyle.layout,
        title: {
            text: `${month.format('YYYY年M月')} 客単価・平均注文数`,
        },
        xaxis: {
            ...plotlyStyle.layout.xaxis,
            title: '注文番号',
            showticklabels: false,
        },
        yaxis: {
            ...plotlyStyle.layout.yaxis,
            title: '客単価 (円)',
            tickformat: ',.0f',
            ticksuffix: '円',
        },
        yaxis2: {
            title: '平均注文数',
            overlaying: 'y',
            side: 'right',
        },
        legend: {
            orientation: 'h',
            y: -0.2,
        },
    };

    return (
        <>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="ja"
            >
                <Stack spacing={2} sx={{ mb: 2 }}>
                    <DatePicker
                        views={['year', 'month']}
                        label="対象月"
                        value={month}
                        onChange={(value) => value && setMonth(value)}
                        format="YYYY年M月"
                        slotProps={{
                            textField: {
                                size: 'small',
                            },
                        }}
                    />
                </Stack>
            </LocalizationProvider>

            <div>
                <Plot
                    data={plotData}
                    layout={layout}
                    style={{
                        width: '100%',
                        height: '100%',
                        minHeight: 500,
                    }}
                    useResizeHandler={true}
                />
            </div>
        </>
    );
};

export default ChartUnitPrice;